import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#top", testid: "nav-link-home" },
  { label: "Chi Siamo", href: "#chi-siamo", testid: "nav-link-about" },
  { label: "Servizi", href: "#attivita", testid: "nav-link-services" },
  { label: "Realizzazioni", href: "#realizzazioni", testid: "nav-link-works" },
  { label: "Render 3D", href: "#perche", testid: "nav-link-render" },
  { label: "Contatti", href: "#contatti", testid: "nav-link-contact" },
];

export const scrollToSection = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (hash) => {
    setOpen(false);
    scrollToSection(hash);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 border-b ${
        scrolled ? "bg-[#F4F1EA]/92 backdrop-blur-xl border-black/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 h-[76px] flex items-center justify-center">
        <nav className="hidden lg:flex items-center gap-3">
          {links.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className="rounded-full border border-[#1C1B1A]/25 bg-white/60 px-8 py-2.5 text-[11px] font-bold uppercase tracking-[0.18em] text-[#1C1B1A] transition-[background-color,color,border-color] duration-300 hover:bg-[#1C1B1A] hover:text-[#F4F1EA] hover:border-[#1C1B1A]"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden absolute right-6 text-[#1C1B1A] p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#F4F1EA]/97 backdrop-blur-xl border-t border-black/10">
          <div className="px-6 py-8 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-${l.testid}`}
                onClick={() => go(l.href)}
                className="text-left font-display text-3xl font-medium text-[#1C1B1A] hover:text-[#E30613] transition-colors duration-300"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
